import React, {useEffect, useState} from "react";
import server from "../../../server";
import dayjs from "dayjs";
import AttendanceChart from "./attendance-chart";
import StatsChart from "../../common/stats-chart/stats-chart";
import {PieChart as PieIcon} from "lucide-react";
import {useNavigate} from 'react-router-dom';

interface IAttendanceData {
    data: string;
    activeEmployee: number;
    present: number;
    absent: number;
    onLeave: number;
}

const AdminAttendanceCard = () => {
    const [attendanceData, setAttendanceData] = useState<IAttendanceData>();
    const [loading, setLoading] = useState(true);
    const todayDate = dayjs().format('YYYY-MM-DD');
    const navigate= useNavigate();


    const handleOnClick = () => {
        navigate('/employee/attendance')
    }


    useEffect(() => {
            fetchAttendanceData();
    }, []);

    async function fetchAttendanceData() {
        setLoading(true);
        try {
            const attendance = await server.attendance.admin.count(todayDate);
            setAttendanceData(attendance);
        } catch (e) {
            console.log("Error while fetching admin-attendance-card", e)
        } finally {
            setLoading(false)
        }
    }

    return (
            <StatsChart
                icon={PieIcon}
                title="Today's Attendance"
                badge={{
                    text: `${attendanceData?.activeEmployee ? `${attendanceData.activeEmployee} Employees ` : ""} `,
                    color: "green"
                }}
                subtitle={'Real-time attendance overview.'}
                onClick={handleOnClick}
                className={'dashboard-attendance-card'}
            >
                <AttendanceChart
                    activeEmployee={attendanceData?.activeEmployee}
                    present={attendanceData?.present}
                    absent={attendanceData?.absent}
                    onLeave={attendanceData?.onLeave}
                    loading={loading}
                />
            </StatsChart>
    )
}

export default AdminAttendanceCard;
